import type * as React from 'react';
import { Helmet } from 'react-helmet-async';
import type { HelmetProps } from 'react-helmet-async';

/* eslint-disable @typescript-eslint/no-var-requires */
const IbmPlexMonoBold = require('../assets/ibm-plex-mono-bold.woff');
const IbmPlexSansBold = require('../assets/ibm-plex-sans-bold.woff');
const IbmPlexSansRegular = require('../assets/ibm-plex-sans-regular.woff');
const OpenSansBold = require('../assets/open-sans-bold.woff');
const OpenSansCnLt = require('../assets/open-sans-condensed-light.woff');
const OpenSansHebrewBold = require('../assets/open-sans-hebrew-bold.ttf');
const OpenSansHebrewRegular = require('../assets/open-sans-hebrew-regular.ttf');
const OpenSansLt = require('../assets/open-sans-light.woff');
const OpenSansRegular = require('../assets/open-sans-regular.woff');
const OpenSansSemibold = require('../assets/open-sans-semibold.woff');
const PromptBold = require('../assets/prompt-bold.ttf');
const PromptRegular = require('../assets/prompt-regular.ttf');
/* eslint-enable @typescript-eslint/no-var-requires */

const fonts = [
  {
    fontFamily: 'OpenSans Lt',
    woff: OpenSansLt,
    fontWeight: 400,
  },
  {
    fontFamily: 'OpenSans Cn Lt',
    woff: OpenSansCnLt,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansSemibold,
    fontWeight: 600,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'IBM Plex Mono',
    woff: IbmPlexMonoBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'IBM Plex Sans',
    woff: IbmPlexSansRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'IBM Plex Sans',
    woff: IbmPlexSansBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Prompt',
    woff: PromptBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Prompt',
    woff: PromptRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans Hebrew',
    woff: OpenSansHebrewBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Open Sans Hebrew',
    woff: OpenSansHebrewRegular,
    fontWeight: 400,
  },
];

const fontsString = fonts
  .map(({ fontFamily, fontWeight, woff }) => {
    return `
      @font-face {
        font-family: "${fontFamily}";
        font-display: block;
        font-weight: ${fontWeight};
        src: url(${woff}) format("woff");
      }`;
  })
  .join('')
  .replace(/\n|^\s+/gm, '');

// preload web fonts
const link = fonts.map(({ woff }) => ({
  href: woff,
  rel: 'preload',
  as: 'font',
  crossorigin: 'anonymous',
  type: 'font/woff',
}));

const style = [
  {
    cssText: fontsString,
  },
];

const props: HelmetProps = {
  style,
  link,
};

export const TemplateGlobalStyles: React.FC = () => {
  return <Helmet {...props} />;
};
